export function isElementFocused(element: HTMLElement): boolean {
    return element === document.activeElement;
}

export const wcsFocusableElements = [
    'wcs-select',
    'wcs-select-option',
    'wcs-dropdown',
    'wcs-dropdown-item',
    'wcs-nav-item',
    'wcs-button',
    'wcs-input',
    'wcs-textarea',
    'wcs-checkbox',
    'wcs-radio',
    'wcs-switch',
    'wcs-tab',
    'wcs-counter',
];

/**
 * Returns true if the provided element is part of the wcsFocusableElements list
 */
export function isWcsFocusableElement(element: any): boolean {
    return wcsFocusableElements.includes(element.tagName.toLowerCase());
}

export function isFocusable(element: any): boolean {
    if (parseInt(element.getAttribute('tabindex')) < 0) {
        return false;
    }
    if (element.disabled) {
        return false;
    }
    const boundingRect = element.getBoundingClientRect();
    if (
        boundingRect.bottom === 0 &&
        boundingRect.top === 0 &&
        boundingRect.left === 0 &&
        boundingRect.right === 0 &&
        boundingRect.height === 0 &&
        boundingRect.width === 0 &&
        boundingRect.x === 0 &&
        boundingRect.y === 0
    ) {
        return false;
    }
    if (
        element.style.display === 'none' ||
        element.style.visibility === 'hidden' ||
        element.style.opacity === 0
    ) {
        return false;
    }
    if (element.getAttribute('role') === 'button') {
        return true;
    }

    if (isWcsFocusableElement(element)) {
        return true;
    }

    // To identify other native focus elements.
    switch (element.nodeName) {
        case 'A':
            return !!element.href && element.rel !== 'ignore';
        case 'INPUT':
            return element.type !== 'hidden';
        case 'BUTTON':
        case 'SELECT':
        case 'TEXTAREA':
            return true;
        default:
            return false;
    }
}

/**
 * Finds the next focusable element after the given startElement.
 * It checks the next siblings of the startElement and returns the first focusable element found.
 * If no focusable element is found, it returns null.
 * @param startElement The element from which to start searching for the next focusable element.
 */
export function findNextFocusableElement(startElement: HTMLElement): HTMLElement | null {
    let nextElement = startElement.nextElementSibling;
    while (nextElement) {
        if (isFocusable(nextElement) && nextElement instanceof HTMLElement) {
            return nextElement;
        }
        nextElement = nextElement.nextElementSibling;
    }
    return null;
}
